window.addEventListener('load', () => {
  const zt_active_swatch = function() {
    let active = document.querySelectorAll('#MainContent .rio-options div[data-option-type="swatch"] div[role="button"].active');
    if(active.length > 0) {
      for(let i = 0; i < active.length; i++){
        active[i].classList.remove('active')
      }
    }
    this.classList.add('active')
  }
  
  let buttons = document.querySelectorAll('#MainContent .rio-options div[data-option-type="swatch"] div[role="button"]');
  // document.onload = function() {
    
  for(let i = 0; i < buttons.length; i++){
    if(buttons[i].style.border == '1px solid rgb(50, 50, 50)'){
      buttons[i].classList.add('active')
    }
    buttons[i].addEventListener('click', zt_active_swatch)
  }
});